// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  db: {
    schema: 'rism',
  },
  auth: {
    autoRefreshToken: true,   // keep tokens fresh
    persistSession: true,     // save session to localStorage
    detectSessionInUrl: true, // catch login callbacks from Supabase
  },
});
